import { WalletReadyState } from '@solana/wallet-adapter-base';
import React from 'react';
import { Button } from './Button.mjs';
import { WalletIcon } from './WalletIcon.mjs';
export var WalletListItem = function WalletListItem(_ref) {
  var handleClick = _ref.handleClick,
      tabIndex = _ref.tabIndex,
      wallet = _ref.wallet;
  return React.createElement("li", null, React.createElement(Button, {
    onClick: handleClick,
    startIcon: React.createElement(WalletIcon, {
      wallet: wallet
    }),
    tabIndex: tabIndex
  }, wallet.adapter.name, wallet.readyState === WalletReadyState.Installed && React.createElement("span", null, "Detected")));
};